import { createAction, props } from '@ngrx/store';
import { IPendingCounts } from '@shared';

export const loadPendingCounts = createAction('[Pending Counts] Load Pending Counts');
export const loadPendingCountsSuccess = createAction(
  '[Pending Counts] Load Pending Counts Success',
  props<{ pendingCounts: IPendingCounts }>(),
);
